<template>
    <DsTooltip
        :closeDelay="100"
        :hideTooltipOnClick
        :openDelay="500"
        :tooltipLocation
        :tooltipText
    >
        <DsButton
            :aria-label="$attrs['aria-label'] || tooltipText"
            iconOnly
            :onDarkBg
            :size
            variant="icon"
            v-bind="$attrs"
        >
            <DsIcon
                class="align-middle"
                data-testid="ds-icon"
                :icon
                :size="iconSize"
                :spin
            />
        </DsButton>
    </DsTooltip>
</template>

<script setup lang="ts">
import DsIcon, { type DsIconProps } from '@ds/DsIcon.vue';
import DsButton from '@ds/button/DsButton.vue';
import DsTooltip from '@ds/tooltip/DsTooltip.vue';
import type { FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';
import type { TooltipPlacementType } from '../design-system';

export type IconButtonSize = 'md' | 'sm' | 'xs';

export interface DsIconButtonProps {
    icon: FontAwesomeIconProps['icon'];
    onDarkBg?: boolean;
    size: IconButtonSize;
    spin?: boolean;
    tooltipLocation?: TooltipPlacementType;
    tooltipText: string;
    hideTooltipOnClick?: boolean;
}

const props = withDefaults(defineProps<DsIconButtonProps>(), {
    onDarkBg: false,
    tooltipLocation: 'top',
    spin: false,
    hideTooltipOnClick: true,
});

const ICON_SIZE_BY_BUTTON_SIZE = {
    xs: 'sm',
    sm: 'md',
    md: 'lg',
} as const satisfies Record<IconButtonSize, DsIconProps['size']>;

const iconSize = computed(() => ICON_SIZE_BY_BUTTON_SIZE[props.size]);
</script>
